import { useState, useEffect } from 'react'
import { Edit2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'
import { cn } from '@/lib/utils'

export interface InlineEditProps {
  value: string
  onSave: (val: string) => void
  className?: string
  textarea?: boolean
}

/**
 * 内联编辑组件
 * 点击文本进入编辑模式
 */
export function InlineEdit({
  value,
  onSave,
  className,
  textarea,
}: InlineEditProps) {
  const [isEditing, setIsEditing] = useState(false)
  const [tempValue, setTempValue] = useState(value)

  useEffect(() => {
    setTempValue(value)
  }, [value])

  if (isEditing) {
    return (
      <div className="relative">
        {textarea ? (
          <Textarea
            value={tempValue}
            onChange={e => setTempValue(e.target.value)}
            className="min-h-[200px] text-base resize-none"
            autoFocus
          />
        ) : (
          <Input
            value={tempValue}
            onChange={e => setTempValue(e.target.value)}
            className="font-bold text-lg"
            autoFocus
          />
        )}
        <div className="flex gap-2 mt-2 justify-end">
          <Button size="sm" variant="ghost" onClick={() => setIsEditing(false)}>
            取消
          </Button>
          <Button
            size="sm"
            onClick={() => {
              onSave(tempValue)
              setIsEditing(false)
            }}
          >
            保存
          </Button>
        </div>
      </div>
    )
  }

  return (
    <div
      onClick={() => setIsEditing(true)}
      className={cn(
        className,
        'cursor-text hover:bg-gray-50 rounded px-1 -mx-1 border border-transparent hover:border-gray-200 transition-colors relative group'
      )}
    >
      {value}
      <Edit2 className="w-3 h-3 absolute -right-4 top-1 text-muted-foreground opacity-0 group-hover:opacity-100" />
    </div>
  )
}

